
export class EventBus {
    constructor() {

        if (EventBus.instance) { return EventBus.instance;}

        this.listeners = {};
        EventBus.instance = this;
        return this;
    }

    on(event, callback) {

        if (!this.listeners[event]) { this.listeners[event] = [];}
        this.listeners[event].push(callback);
    }

    off(event, callback) {
        if (!this.listeners[event]) { return;}
        this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }

    emit(event, data) {
        if (!this.listeners[event]) { return;}
        this.listeners[event].forEach(cb => cb(data));
    }
}